import React from "react";
import PropTypes from "prop-types";
import UserDataService from "../common/UserDataService";
import {fetchResponseHandler} from "../../util/FetchUtil";
import ProcessingComponent from "../../util/ProcessingComponent";
import UniversalDuoInfoComponent from "./UniversalDuoInfoComponent";
 /*
 * This is for DUO Universal Prompt.
 * */
class DuoAuthSetupComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
        this.setShowProcessing = this.setShowProcessing.bind(this);
        this.hideProcessing = this.hideProcessing.bind(this);
        this.showProcessing = this.showProcessing.bind(this);
        this.onDuoCall = this.onDuoCall.bind(this);
        this.setDuoWindow = this.setDuoWindow.bind(this);
        this.setDuoState = this.setDuoState.bind(this);
        this.clearDuoSession = this.clearDuoSession.bind(this);
        this.onDuoAuthSetupError = this.onDuoAuthSetupError.bind(this);
        this.checkManageDuoStatus = this.checkManageDuoStatus.bind(this);
        this.onDuoAuthSetupSuccess = this.onDuoAuthSetupSuccess.bind(this);
    }

    onDuoAuthSetupError(e){
        this.clearDuoSession();
        this.hideProcessing();
        const {onError} = this.props;
        onError(e);
    }

    onDuoAuthSetupSuccess(){
        this.hideProcessing();
        const {onSuccess} = this.props;
        onSuccess();
    }
    setShowProcessing(showProcessing){
        this.setState(state => ({...state, showProcessing}));
    }

    hideProcessing(){
        this.setShowProcessing(false);
    }

    showProcessing(){
        this.setShowProcessing(true);
    }

    componentDidMount() {
        console.log("DuoAuthSetupComponent init")
    }

    setDuoWindow(duoWindow){
        this.setState(state => ({...state, duoWindow}));
    }

    setDuoState(duoState){
        this.setState(state => ({...state, duoState}));
    }

    async checkManageDuoStatus(){
        if(this.state.showProcessing && this.state.duoState){
            const {userDataService} = this.props;
            let state = this.state.duoState
            const queryParams = "?state=" + encodeURIComponent(state);
            userDataService.checkDuoAuthenticationStatus(queryParams)
                .then(fetchResponseHandler)
                .then(data => {
                    if (data.success) {
                        this.onDuoAuthSetupSuccess();
                    } else {
                        if (data.errorMessage != null) {
                            this.hideProcessing();
                            let duoWindow = this.state.duoWindow;
                            duoWindow.close();
                        } else if(this.state.duoWindow.closed) {
                            console.log("DUO window closed.")
                            this.onDuoAuthSetupError("DUO window closed.");
                        }else{
                            setTimeout(this.checkManageDuoStatus, 2000);
                        }
                    }
                })
                .catch(e => this.onDuoAuthSetupError(e));
        }
    };

    async clearDuoSession(){
        if(this.state.duoState){
            const {userDataService,onError} = this.props;
            let state = this.state.duoState
            //const queryParams = "?state=" + encodeURIComponent(state);
            const queryParams = "?state=" + encodeURIComponent(state);
            userDataService.clearDuoSession(queryParams)
                .then(fetchResponseHandler).then(response => {
                console.log("Duo session clear status",response.success);
            }).catch(e => this.onDuoAuthSetupError(e));
        }
    }

    onDuoCall() {
        const {userDataService} = this.props;
        this.showProcessing();
        userDataService.getDuoAuthUrl()
            .then(fetchResponseHandler)
            .then(response => {
                if(response.success){
                    let url = response.data.URL;
                    let duoState = response.data.duoState;
                    let duoWindow = window.open(url);
                    if(duoWindow != null){
                        this.setDuoWindow(duoWindow);
                        this.setDuoState(duoState);
                        this.checkManageDuoStatus();
                    }else{
                        this.onDuoAuthSetupError("It appears your browser's pop-up blocker is preventing this content from loading. Please allow pop-ups to view this content.");
                    }

                }else{
                    console.log("Error message:",response.errorMessage);
                    this.onDuoAuthSetupError("Error occurred in processing your request.")
                }
            })
            .catch(e => this.onDuoAuthSetupError(e));
    }

    render(){
        const {showProcessing} = this.state;
        const {onCancel} = this.props;
        return (
            <div>
                <UniversalDuoInfoComponent />
                <button className="btn btn--large btn--outline" onClick={this.onDuoCall}>DUO SETTINGS </button>
                <ProcessingComponent show={showProcessing} />
            </div>
        );
    }

}

DuoAuthSetupComponent.propTypes = {
    userDataService: PropTypes.instanceOf(UserDataService).isRequired,
    onError: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onCancel: PropTypes.func
};

export default DuoAuthSetupComponent;
